// extracted by mini-css-extract-plugin
export default {"labeltxt":"EntityEditor_labeltxt__PDluV","deleteCondButton":"EntityEditor_deleteCondButton__GzQu9","deleteCondIcon":"EntityEditor_deleteCondIcon__MtorB"};